export default "__VITE_ASSET__CAkNBBRU__"